var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJamfProtect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M1.45237 0.49957C1.14996 0.50094 0.905872 0.747195 0.907232 1.04962L0.924285 4.83583C0.925645 5.13063 1.16565 5.36855 1.46044 5.36718L3.3687 5.35857C4.24219 5.35467 5.44058 5.1699 5.76295 3.6173C5.76314 3.61693 6.08324 2.06252 6.27299 1.14113C6.34347 0.798443 6.0807 0.478719 5.73084 0.480251L1.45237 0.49957Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M8.76331 2.26266C7.47473 2.26847 6.71581 2.81452 6.3743 3.9808C6.37493 3.97845 5.48937 6.75821 5.48937 6.75821C5.16437 7.67115 4.63638 8.04911 3.66955 8.05347L1.45136 8.06346C1.16845 8.06471 0.940142 8.29511 0.941412 8.57812L0.947761 9.99267C0.949031 10.2632 1.16935 10.4816 1.43993 10.4805L10.4426 10.4398C10.725 10.4386 10.9528 10.2086 10.9516 9.92635L10.9192 2.74586C10.9179 2.47364 10.6963 2.25395 10.424 2.25523L8.76331 2.26266Z",
    fill: "#444444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamfProtect);
export default __webpack_public_path__ + "static/media/JamfProtect.c1963a4969dc72f90d78ea8955fd766d.svg";
export { ForwardRef as ReactComponent };